import { defineRefiElement } from '../../utils/define-refi-element.js';
import { RefiSkeletonLoader } from './skeleton-loader.component.js';
import '../../lit-element.js';
import '../../fs-heading.js';
import '../../query-assigned-elements.js';
import '../../index2.js';

defineRefiElement('refi-common-skeleton-loader', RefiSkeletonLoader);
